export const prettifyCustomFieldId = (fieldId: string) => {
  if (fieldId) {
    return fieldId.replace('customfield_', '');
  }
  return null;
};
